import React from 'react';
import Component from '../../_shared/components/component.js';
import { Route, Switch } from 'react-router';
import PostContainer from './post-container.js';
import PostsContainer from './posts-container.js';

export default class Main extends Component {
  render() {
    return pug`
      main
        Switch
          Route(path='/posts/:postName')
            PostContainer
          Route
            PostsContainer
    `;
  }
}
